import { createAction } from '@reduxjs/toolkit';

export const menuUpdateId = createAction('menu/updateId');
export const menuUpdateUID = createAction('menu/updateUid');
export const menuUpdateSID = createAction('menu/updateSid');
export const menuUpdateIsAdded = createAction('menu/updateIsAdded');
export const menuUpdateIsActive = createAction('menu/updateIsActive');

export const menuStore = createAction('menu/store');
export const menuClear = createAction('menu/clear');

export const menuUpdateRequest = createAction('menu/updateRequest');
export const menuUpdateIsLoading = createAction('menu/updateIsLoading');
export const menuUpdateError = createAction('menu/updateError');
export const menuUpdateStore = createAction('menu/updateStore');

export const menuUpdateItems = createAction('menu/updateItems');
export const menuUpdateHeading = createAction('menu/updateHeading');
export const menuUpdateBlockContent = createAction('menu/updateBlockContent');
export const menuUpdateBlockDesign = createAction('menu/updateBlockDesign');
